import React from 'react'
import CatalogSvg from 'assets/icons/libraries.svg'
import LockSvg from 'assets/icons/lock.svg'
import ExternalLinkSvg from 'assets/icons/external-link.svg'
import ArrowDropDownSvg from 'assets/icons/arrow-down.svg'
import EllipsisVerticalSvg from 'assets/icons/ellipsis-vertical.svg'

const SvgIcon = ({ Icon, size = 24, color }: IconProps & { Icon: any }) => (
  <Icon width={size} height={size} color={color} />
)

type IconProps = {
  size?: number
  color?: string
}
export const CatalogIcon = (props: IconProps): React.ReactNode =>
  SvgIcon({ ...props, Icon: CatalogSvg })

export const LockIcon = (props: IconProps): React.ReactNode =>
  SvgIcon({ ...props, Icon: LockSvg })

export const ExternalLinkIcon = (props: IconProps): React.ReactNode =>
  SvgIcon({ ...props, Icon: ExternalLinkSvg })

export const ArrowDropDownIcon = (props: IconProps): React.ReactNode =>
  SvgIcon({ ...props, Icon: ArrowDropDownSvg })

export const EllipsisVerticalIcon = (props: IconProps): React.ReactNode =>
  SvgIcon({ ...props, Icon: EllipsisVerticalSvg })
